import React, { useState, useEffect, useContext } from "react";

import styles from "./styles/CredentialsMenu.module.css"
import CredStored from "./CredStored";
import CredNotStored from "./CredNotStored";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

function CredentialsMenu({value, onChange, formErrors}) {
    const [election, setElection]=useState(1)
    const websiteCurrentLang = useContext(LanguageContext).language;

    const [content, setContent] = useState(
        websiteCurrentLang.content.User.EditAsset.CredentialsMenu
    );
    const [dublicatedcontent, setDublicatedContent] = useState(
        websiteCurrentLang.content.DublicatedText
    );
    useEffect(() => {
        setContent(websiteCurrentLang.content.User.EditAsset.CredentialsMenu);
        setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    }, [websiteCurrentLang]);
    const elections = [
        dublicatedcontent.dublicatedText60,
        content.credentialsMenuText2,
        content.credentialsMenuText3,
    ];
    let CredentialOptions = null
    switch(election){
        case 1:
            CredentialOptions=null
            break
        case 2:
            CredentialOptions=<CredStored value={value} onChange={onChange} formErrors={formErrors} />
            break
        case 3:
            CredentialOptions=<CredNotStored value={value} onChange={onChange} formErrors={formErrors} />
            break
        default:
            break
    }

    useEffect(()=>{
        var credentials
        try{
            credentials=JSON.parse(value)
        }
        catch{
            credentials={
                record_name:dublicatedcontent?.dublicatedText60
            }
        }
        console.log("Credentials:", credentials)
        if (!Object.keys(credentials).includes("record_name")){
            console.log('No incluye record_name')
            console.log(Object.keys(credentials))
            setElection(3)
            return 
        }
        if (credentials["record_name"]==="This assets has no credentials") return setElection(1)
        else  return setElection(2)
        // {
        //     if (credentials["record_name"]==="This assets has no credentials") setElection(1)
        //     else{
        //         setElection(1)
        //     }
        // }
    }, [value])
    
    return (
        <>
        <div className={styles.menu}>
            <div onClick={()=>{setElection(1);onChange({"record_name":"This assets has no credentials"})}} className={styles.main}>
                <div className={styles.deactivated}>
                    {
                        (election===1)?<div className={styles.activated}/>
                        :null
                    }
                </div>
                <div className={styles.option}>{elections[0]}</div>
            </div>
            {election===1?CredentialOptions:null}

            <div onClick={()=>setElection(2)} className={styles.main}>
                <div className={styles.deactivated}>
                    {
                        (election===2)?<div className={styles.activated}/>
                        :null
                    }
                </div>
                <div className={styles.option}>{elections[1]}</div>
            </div>
            {election===2?CredentialOptions:null}
            <div onClick={()=>setElection(3)} className={styles.main}>
                <div className={styles.deactivated}>
                    {
                        (election===3)?<div className={styles.activated}/>
                        :null
                    }
                </div>
                <div className={styles.option}>{elections[2]}</div>                
            </div>
            {election===3?CredentialOptions:null}

        </div>
       
        </>
    );
}

export default CredentialsMenu;
